module.exports = __webpack_public_path__ + "img/relaxing-guy.044540c.svg";